import PageLayout from 'pages/InstructorViewFormativeSubmission/PageLayout';
import PageProvider from 'pages/InstructorViewFormativeSubmission/PageProvider';

const InstructorViewFormativeSubmissionPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorViewFormativeSubmissionPage;
